module.exports = __webpack_public_path__ + "static/blue-zoom-09891b723deab10dd232cf950c035682.jpg";